<template>
  <div class="shopmarketing">
    <div
      class="flex between"
      style="padding-right: 20px"
    >
      <div class="page_title"> 医生开方活动统计 — {{act_name}}（{{start_time}}至{{end_time}}）
      </div>
      <el-button
        type="primary"
        size="medium"
        @click="back"
        style="width: 120px"
      >返回</el-button>
    </div>
    <div style="padding:20px;">
      <div class="flex_between header">
        <div class="item">
          <div>
            <span class="green">{{count_data.total_num}}</span>
            <span>({{count_data.total_num_no_settle}})</span>
            <span>
              <el-popover
                placement="bottom"
                trigger="hover"
                content="总开方数量（待结算开方数量）"
              >
                <el-button
                  slot="reference"
                  type="text"
                ><i class="el-icon-question"></i></el-button>
              </el-popover>
            </span>
          </div>
          <div class="top_title">
            总开方量
          </div>
        </div>
        <div class="item">
          <div>
            <span class="green">{{count_data.total_up_num}}</span>
            <span>({{count_data.total_up_num_no_settle}})</span>
            <span>
              <el-popover
                placement="bottom"
                trigger="hover"
                content="达标总开方数量（待结算达标总开方数量）"
              >
                <el-button
                  slot="reference"
                  type="text"
                ><i class="el-icon-question"></i></el-button>
              </el-popover>
            </span>
          </div>
          <div class="top_title">
            达标总开方量
          </div>
        </div>
        <div
          class="item"
          style="width:22%"
        >
          <div>
            <span
              class="green">￥{{count_data.total_pre_money?count_data.total_pre_money.toFixed(2):0}}</span>
            <span>({{count_data.total_pre_money_no_settle?count_data.total_pre_money_no_settle.toFixed(2):0}})</span>
            <span>
              <el-popover
                placement="bottom"
                trigger="hover"
                content="开方总额（待结算开方总额）"
              >
                <el-button
                  slot="reference"
                  type="text"
                ><i class="el-icon-question"></i></el-button>
              </el-popover>
            </span>
          </div>
          <div class="top_title">
            开方总金额
          </div>
        </div>
        <div
          class="item"
          style="width:22%"
        >
          <div>
            <span
              class="green">￥{{count_data.total_dug_money?count_data.total_dug_money.toFixed(2):0}}</span>
            <span>({{count_data.total_dug_money_no_settle?count_data.total_dug_money_no_settle.toFixed(2):0}})</span>
            <span>
              <el-popover
                placement="bottom"
                trigger="hover"
                content="药费总额（待结算药费总额）"
              >
                <el-button
                  slot="reference"
                  type="text"
                ><i class="el-icon-question"></i></el-button>
              </el-popover>
            </span>
          </div>
          <div class="top_title">
            药费总金额
          </div>
        </div>
        <div
          class="item"
          style="width:20%"
        >
          <div>
            <span class="green">￥{{count_data.total_awards_money}}</span>
            <span>({{count_data.total_awards_money_no_settle}})</span>
            <span>
              <el-popover
                placement="bottom"
                trigger="hover"
                content="奖励总额（待结算奖励总额）"
              >
                <el-button
                  slot="reference"
                  type="text"
                ><i class="el-icon-question"></i></el-button>
              </el-popover>
            </span>
          </div>
          <div class="top_title">
            奖励总额
          </div>
        </div>
      </div>
      <div class="container">
        <div
          class="flex_between"
          style="margin-bottom: 10px;"
        >
          <div class="searchbox">
            <div class="item">
              <span>医生名字</span>
              <el-input
                v-model="doctor_name"
                style="width: 120px; margin-left: 6px"
                clearable
                @change="search"
              ></el-input>
            </div>
            <div class="item">
              <span>医生手机号</span>
              <el-input
                v-model="phone"
                style="width: 120px; margin-left: 6px"
                clearable
                @change="search"
              ></el-input>
            </div>
            <div class="item">
              <span>奖励次数</span>
              <el-input-number
                v-model="start_num"
                @change="search"
                :precision="0"
                :controls="false"
                style="width:90px;margin-left:6px"
              ></el-input-number>
              <span style="margin:0 8px">~</span>
              <el-input-number
                v-model="end_num"
                @change="search"
                :precision="0"
                :controls="false"
                style="width:90px"
              ></el-input-number>
            </div>
            <div class="item">
              <span>备注信息</span>
              <el-input
                v-model="remark"
                style="width: 120px; margin-left: 6px"
                clearable
                @change="search"
              ></el-input>
              <el-button
                type="info"
                style="background-color: #eceff2; color: #747981;margin-left: 6px"
                @click="search"
              >查询</el-button>
            </div>
            <div class="item">
              <span style="margin-right: 6px">是否备注</span>
              <span>
                <el-radio-group v-model="is_remark">
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </span>
            </div>
            <div class="item">
              <span style="margin-right: 6px">是否测试医生</span>
              <span>
                <el-radio-group v-model="is_test">
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </span>
            </div>
          </div>
          <el-button
            type="primary"
            @click="excelexport"
            style="width:92px"
            :disabled="module_id_array[0] ? !module_id_array.includes('1020') : false"
          >导出</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change='sortChange'
          >
            <el-table-column label="医生信息">
              <template slot-scope="scope">
                <div>{{scope.row.doctor_name}}</div>
                <div>{{scope.row.phone}}</div>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="total_num"
            >
              <template slot="header">
                <div>开方总数量</div>
                <span style="color:#787878;font-size:12px">(待结算数/总数)</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{scope.row.total_num_no_settle}}/{{scope.row.total_num}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="达标开方总数量"
              prop="total_up_num"
            >
              <template slot="header">
                <div>达标开方总数量</div>
                <span style="color:#787878;font-size:12px">(待结算达标数/达标总数)</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{scope.row.total_up_num_no_settle}}/{{scope.row.total_up_num}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="开方总金额"
              prop="total_pre_money"
              sortable="custom"
            >
              <template slot="header">
                <div>开方总金额</div>
                <span style="color:#787878;font-size:12px">(待结算/开方总额)</span>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.total_pre_money">
                  {{scope.row.total_pre_money_no_settle}}/{{scope.row.total_pre_money}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="开方药费总金额"
              prop="total_dug_money"
              sortable="custom"
            >
              <template slot="header">
                <div>开方药费总金额</div>
                <span style="color:#787878;font-size:12px">(待结算/药费总额)</span>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.total_dug_money">
                  {{scope.row.total_dug_money_no_settle}}/{{scope.row.total_dug_money}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="奖励次数"
              prop="awards_num"
              sortable="custom"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.awards_num">
                  {{scope.row.awards_num}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="最近开方"
              prop="pre_create_time"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="备注">
              <template slot-scope="scope">
                <div class="remark">{{scope.row.remark}}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toDetail(scope.row.doctor_id,scope.row.doctor_name)"
                  :disabled="
                module_id_array[0] ? !module_id_array.includes('1022') : false
              "
                >详情</el-button>
                <el-button
                  type="text"
                  @click="setRemark(scope.row.doctor_id)"
                  :disabled="
                module_id_array[0] ? !module_id_array.includes('1021') : false
              "
                >备注</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      doctor_name: '',
      phone: '',
      start_num: undefined,
      end_num: undefined,
      remark: '',
      is_test: '',
      is_remark: '',
      order_key: '',
      order_value: '',
      count_data: {},
      act_id: '',
      act_name: '',
      start_time: '',
      end_time: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        act_id: this.act_id,
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        start_num: this.start_num,
        end_num: this.end_num,
        remark: this.remark,
        is_test: this.is_test,
        is_remark: this.is_remark,
        order_key: this.order_key,
        order_value: this.order_value
      };
      this.axios
        .post('platform/doctor/doctorActivityCount', data)
        .then((res) => {
          if (res.code == 0) {
            let list = res.data.list.map((item) => {
              item.pre_create_time = item.pre_create_time
                ? dayjs.unix(item.pre_create_time).format('YYYY-MM-DD HH:mm')
                : '';
              item.total_pre_money = Number(item.total_pre_money)
                ? item.total_pre_money
                : '';
              item.total_dug_money = Number(item.total_dug_money)
                ? item.total_dug_money
                : '';

              return item;
            });
            this.count_data = res.data.count_data;
            this.tableData = list;
            this.totalNum = res.data.total;
          }
        });
    },
    sortChange(e) {
      let order = e.order;
      this.order_key = e.prop;
      if (order == 'descending') {
        this.order_value = 'desc';
      } else if (order == 'ascending') {
        this.order_value = 'asc';
      } else {
        this.order_key = '';
        this.order_value = '';
      }
      this.getList();
    },
    //查看详情
    toDetail(doctor_id, doctor_name) {
      this.$router.push({
        path: 'statisticsdetail',
        query: {
          act_id: this.act_id,
          doctor_id: doctor_id,
          doctor_name: doctor_name
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //备注
    setRemark(doctor_id) {
      this.$prompt('', '请输入备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false
      })
        .then(({ value }) => {
          if (value.length >= 50) {
            this.$message.error('备注不超过50个字');
            return false;
          }
          let data = {
            act_id: this.act_id,
            doctor_id: doctor_id,
            remark: value
          };
          this.axios
            .post('platform/doctor/doctorActivityRemark', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('保存成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //导出数据
    excelexport() {
      let loading = this.$loading();
      let data = {
        act_id: this.act_id,
        doctor_name: this.doctor_name,
        phone: this.phone,
        start_num: this.start_num,
        end_num: this.end_num,
        remark: this.remark,
        is_test: this.is_test,
        is_remark: this.is_remark,
        order_key: this.order_key,
        order_value: this.order_value
      };
      this.axios
        .post('platform/doctor/exportDoctorActivityCount', data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              '//' +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    back() {
      history.back();
    }
  },
  activated() {
    this.act_id = this.$route.query.act_id;
    this.act_name = this.$route.query.act_name;
    this.start_time = this.$route.query.start_time;
    this.end_time = this.$route.query.end_time;
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 280px);
  margin-top: 20px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 20px;
  }
}
.header {
  .item {
    width: 14%;
    height: 120px;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    align-items: center;
    .icon {
      width: 70px;
      height: 70px;
      margin: 0 20px;
    }
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .green {
      color: #669961;
      font-size: 30px;
      font-weight: 700;
      margin-right: 5px;
    }
    .top_title {
      font-weight: 700;
      margin-top: 5px;
    }
  }
}
.remark {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>